import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import { formatPhone } from '../../../../../../util/phone';
import PinField from '../../../../../../components/global/PinField';
import useVirtualPageView from '../../../../../pro/services/analytics/useVirtualPageView';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
};

const RegistrationPhoneVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  values,
}) => {
  const classes = classNames({
    [className]: !!className,
    'text-center': true,
  });
  const isValid = values.code?.length === 4;

  useVirtualPageView({
    title:
      'Reserve Waldo for your wedding today! - Phone Authentication Verify',
    path: '/phone-auth-verify',
  });

  return (
    <div className={classes}>
      <h4 className="view-register-form-title text-center justify-content-center mb-3">
        <span className="view-register-form-title-main">
          Please enter the code that was sent to:
          <span className="d-block text-normal">
            {formatPhone(values.phone_number)}
          </span>
        </span>
      </h4>

      <form className="text-center" onSubmit={handleSubmit}>
        <div className="mb-3">
          <PinField
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <div className="d-flex flex-column align-items-center justify-content-start">
          <Button
            type="submit"
            btnSize="lg"
            disabled={loading || !isValid}
            loading={loading}
            className="view-register-cta"
          >
            {loading ? 'Processing...' : 'Verify Pin Code'}
          </Button>
          <Button
            type="button"
            btnStyle="link"
            disabled={loading}
            loading={loading}
            className="mt-2"
            onClick={() => onPinCodeResend(values)}
          >
            Re&ndash;send code
          </Button>
        </div>
      </form>
    </div>
  );
};

RegistrationPhoneVerify.propTypes = propTypes;

export default RegistrationPhoneVerify;
